import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import Translate from '@client/components/shared/translation/Translate';

import { timeToArray } from '../../../helpers';

import styles from './specialCountdown.scss';

/* eslint-disable react/no-did-mount-set-state */

export class SpecialCountdown extends React.Component {

    constructor() {
        super();
        // can not access props in constructor, set timeLeft to 0 for now
        this.state = {
            timeLeft: 0
        };
    }

    render() {
        const [
            days,
            hours,
            minutes,
            seconds
        ] = timeToArray(this.state.timeLeft);

        const allHours = hours + days * 24;
        const fullSeconds = Math.round(seconds);

        return (
            <div styleName="wrapper">
                <div styleName="counter-container">
                    <div styleName="flip">{(allHours - allHours % 10) / 10}</div>
                    <div styleName="flip">{allHours % 10}</div>
                    <div styleName="separator">:</div>
                    <div styleName="flip">{(minutes - minutes % 10) / 10}</div>
                    <div styleName="flip">{minutes % 10}</div>
                    <div styleName="separator">:</div>
                    <div styleName="flip">{(fullSeconds - fullSeconds % 10) / 10}</div>
                    <div styleName="flip">{fullSeconds % 10}</div>
                </div>
                <div styleName="labels-container">
                    <div styleName="label"><Translate message="specialCountdown.hours" /></div>
                    <div styleName="separator"></div>
                    <div styleName="label"><Translate message="specialCountdown.minutes" /></div>
                    <div styleName="separator"></div>
                    <div styleName="label"><Translate message="specialCountdown.seconds" /></div>
                </div>

            </div>
        );
    }

    componentDidMount() {
        this.timer = setInterval(this.tick.bind(this), 1000);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    tick() {
        // Prevent negative numbers in countdowns
        let timeLeft = this.props.dateTill - Date.now();
        if (timeLeft < 0) {
            timeLeft = 0;
            if (this.timer) {
                clearInterval(this.timer);
            }
        }

        this.setState({
            timeLeft
        });
    }
}

SpecialCountdown.propTypes = {
    dateTill: PropTypes.number.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(CSSModules(SpecialCountdown, styles));
